const constantJs = {
  inch2cm: 2.54,
  dashLineColor: '#999999',
  rectLineColor: '#525977',
  catchAreaColor: '#fbfcb5',
  blackAreaColor: 'rgba(0, 0, 0, 0.5)',
  helpLineColor: '#999999',
  roomLineColor: '#666666',
  roomFillColor: 'rgba(214, 214, 214, 0.5)',
  cornerAreaColor: 'rgba(139, 162, 152, 0.5)',
  rectFillColor: '#FF66FF',
  catchFillColor: 'rgba(255, 178, 217, 1)',
  helpTextColor: '#130c0e',
  avlRangeColor: 'rgba(0, 90, 188, 0.2)',
  dashRemainLineColor: '#DC143C',
  canvasBgColor: '#FFFFFF',
  avageBlendColor: '#575E78',
  rectLineWidth: 1.3,
  screenLineWidth: 2.5,
  helpLineWidth: 0.8,
  arrowAngle: 150,
  edgeScreessColor: 'rgba(251, 252, 148, 0.5)',
  arrowColor: '#10218B',
  PROJECTSPEC_CATEGORY_UST: 4,
  PROJECTSPEC_CATEGORY_HOME: 5,
  PROJECTSPEC_TYPE_UST: 1
}

export default constantJs



// WEBPACK FOOTER //
// ./src/common/constant.js